import React from 'react';
import { oohData } from '../utils/oohData';
import { MicroscopeIcon, GraduationCapIcon } from 'lucide-react';
export const AttentionBlueprint: React.FC = () => {
  const {
    methodology
  } = oohData;
  return <div className="bg-white rounded-xl shadow-sm border-l-4 border-l-[#1E90FF] overflow-hidden" data-id="element-4">
      <div className="p-6 flex flex-col lg:flex-row lg:items-center gap-6" data-id="element-5">
        <div className="flex-1" data-id="element-6">
          <div className="flex items-center space-x-2 mb-2" data-id="element-7">
            <div className="p-1.5 bg-[#1E90FF]/10 text-[#1E90FF] rounded-lg" data-id="element-8">
              <MicroscopeIcon className="w-4 h-4" data-id="element-9" />
            </div>
            <span className="text-xs font-semibold text-[#1E90FF] uppercase tracking-wider" data-id="element-10">
              Powered by the {methodology.name}
            </span>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed mb-3 max-w-3xl" data-id="element-11">
            {'Our methodology is built on 17 visual drivers from cognitive psychology that determine what wins those first seconds of attention. Every principle is substantiated with peer-reviewed research.'}
          </p>
          <div className="flex items-center space-x-2 text-xs text-gray-500" data-id="element-12">
            <GraduationCapIcon className="export-icon-down w-4 h-4 flex-shrink-0 text-gray-400" data-id="element-13" />
            <span data-id="element-14">{methodology.source}</span>
          </div>
        </div>

        {/* Credibility stats */}
        <div className="flex gap-3 lg:flex-col lg:min-w-[190px]" data-id="element-15">
          {methodology.stats.map((stat, idx) => <div key={idx} className="flex-1 bg-gray-50 border border-gray-100 rounded-lg px-4 py-3 text-center lg:text-left" data-id="element-16">
              <p className="text-sm font-semibold text-gray-900 leading-tight" data-id="element-17">
                {stat}
              </p>
            </div>)}
        </div>
      </div>
    </div>;
};